var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Banners"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/slider-horizontal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slider-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.58331 15.125V6.87496C4.58331 6.30663 4.60165 5.80246 4.66581 5.35329C4.93165 2.94246 6.06831 2.29163 9.16665 2.29163H12.8333C15.9316 2.29163 17.0683 2.94246 17.3341 5.35329C17.3983 5.80246 17.4166 6.30663 17.4166 6.87496V15.125C17.4166 15.6933 17.3983 16.1975 17.3341 16.6466C17.0683 19.0575 15.9316 19.7083 12.8333 19.7083H9.16665C6.06831 19.7083 4.93165 19.0575 4.66581 16.6466C4.60165 16.1975 4.58331 15.6933 4.58331 15.125Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.83331 17.875V4.125",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.1667 17.4166V3.66663",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanners);
export default __webpack_public_path__ + "static/media/banners.6c4b56f1c76c770937358354f7f62974.svg";
export { ForwardRef as ReactComponent };